import { cn } from "@/lib/utils";

export type MetricItem = {
  metric: string;
  label: string;
  detail: string;
};

type MetricGridProps = {
  items: MetricItem[];
  columns?: 2 | 3;
  className?: string;
};

export function MetricGrid({ items, columns = 3, className }: MetricGridProps) {
  return (
    <div
      className={cn(
        "grid gap-px overflow-hidden rounded-lg border border-border/60 bg-border/60",
        columns === 2 && "sm:grid-cols-2",
        columns === 3 && "sm:grid-cols-3",
        className,
      )}
    >
      {items.map((item) => (
        <div
          key={item.label}
          className="flex flex-col gap-2 bg-card px-6 py-8 transition-colors hover:bg-muted/15"
        >
          <span className="font-mono text-2xl font-semibold tracking-tight text-foreground">
            {item.metric}
          </span>
          <span className="text-sm font-medium text-foreground/90">{item.label}</span>
          <span className="text-xs text-muted-foreground leading-relaxed">{item.detail}</span>
        </div>
      ))}
    </div>
  );
}
